/* Попап «Настройки» из меню аккаунта: три блока — пароль, почта, удаление. */

.sections {
  display: flex;
  flex-direction: column;
  gap: var(--sp-6);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

.section + .section {
  padding-top: var(--sp-6);
  border-top: var(--bw) solid var(--border);
}

.legend {
  margin: 0;
  color: var(--text-3);
  font-size: var(--fs-xs);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.statusRow {
  display: flex;
  align-items: baseline;
  gap: var(--sp-4);
  font-size: var(--fs-sm);
}

.ok {
  color: var(--ok);
}

.warn {
  color: var(--warn);
}

.muted {
  margin: 0;
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.linkBtn {
  border: 0;
  background: none;
  padding: 0;
  color: var(--flight);
  font: inherit;
  font-size: var(--fs-sm);
  cursor: pointer;
}

.linkBtn:hover:not(:disabled) {
  text-decoration: underline;
  text-underline-offset: 2px;
}

.linkBtn:disabled {
  opacity: 0.5;
  cursor: default;
}

/* Опасная зона — та же рамка, что у сообщений об ошибке: цвет один и тот же
   сигнал, «здесь можно всё сломать». Составной селектор .section.danger даёт
   ту же специфичность, что и .section + .section, поэтому порядок в файле
   решает спор без !important — здесь он ниже, значит и побеждает. */
.section.danger {
  padding: var(--sp-4);
  border: var(--bw) solid var(--error-border);
  border-radius: var(--radius-lg);
  background: var(--error-bg);
}

.error {
  margin: 0;
  color: var(--error);
  font-size: var(--fs-sm);
}
